import { TFunction } from "i18next"
import * as Yup from "yup"
import { OperatorFeedbackValues } from "../../../models/Dialogs/operatorFeedbackForm"
import { DIALOG_OPERATION_FEEDBACK_FORM_CONST } from "./DialogOperatorFeedbackForm.const"

export const getValidationSchema = (t: TFunction) => {
    const error = t(
        `${DIALOG_OPERATION_FEEDBACK_FORM_CONST.tNamespace}:${DIALOG_OPERATION_FEEDBACK_FORM_CONST.tPaths.validation}`
    )

    return Yup.object<OperatorFeedbackValues>()
        .shape(
            {
                Score: Yup.number()
                    .default(0)
                    .when("Message", {
                        is: (msg?: string) => !msg?.trim(),
                        then: (schema: Yup.NumberSchema) => schema.min(1, error)
                    }),
                Message: Yup.string()
                    .default("")
                    .when("Score", {
                        is: (score?: number) => !(score && score >= 1),
                        then: (schema: Yup.StringSchema) => schema.required(error)
                    })
            },
            [["Score", "Message"]]
        )
        .required()
}
